/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

// Store functionality
import createPersistedState from 'vuex-persistedstate'
import mutations from './v3/mutations'
import actions from './v3/actions'
import v4 from './v4'
import { logger } from '@/logging/logger'

Vue.use(Vuex)

let v = document.cookie.match('(^|;) ?' + 'session' + '=([^;]*)(;|$)');
if (v) {
    logger.info('auth', 'session.restore.success', { hasSessionCookie: true }, 'Session cookie found during store bootstrap').then();
} else {
    logger.warn('auth', 'session.restore.miss', { hasSessionCookie: false }, 'Session cookie missing during store bootstrap').then();
}
let key = v ? v[2] : 'default';

if (key !== 'default') {
    try {
        window.localStorage.removeItem('default')
    } catch (e) {
        logger.error('storage', 'storage.key.failure', { key: 'default', operation: 'removeItem', message: e?.message }, 'Failed to clear bootstrap storage key').then();
    }
}

const store = new Vuex.Store({
    plugins: [createPersistedState({
        key: decodeURIComponent(key),
        paths: [
            'environment',
            'hashes',
            'preferences',
            'recordsInQueue',
            'release',
            'session',
            'settings',
            'tracks',
            'uploadSequence',
            'v4',
        ]
    })],
    namespaced: true,
    modules: Object.assign({}, { v4: v4 }),
    state: {
        environment: window.thinkmd,
        hashes: {
            preferences: null
        },
        preferences: null,
        recordsInQueue: 0,
        release: {},
        session: {},
        settings: {},
        tracks: [],
        uploadSequence: 0,
    },
    actions: actions,
    mutations: mutations

})

export default store
